import { DrawerComponent } from '~/shared/ui/Drawer'

type ShowMoreDrawerProps = {
  isShow: boolean
  onClose: () => void
  content: string
}

export function ShowMoreDrawer({
  isShow,
  onClose,
  content,
}: ShowMoreDrawerProps) {
  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <div
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </DrawerComponent>
  )
}
